import { Component, Input, OnInit, ViewChild } from "@angular/core";
import * as wjCore from "wijmo/wijmo";
import { ExplorerService } from "app/modules/shared/services/explorer.service";
import { ApiService } from "app/modules/shared/services/base/api.service";
import { Router } from "@angular/router";
import { KlLoadingService } from "app/modules/shared/services/kl-loading.service";
import { UtilService } from "app/modules/shared/services/util.service";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";

declare const moment;

@Component({
  selector: "kl-main",
  templateUrl: "./main.component.html",
  styleUrls: ["./main.component.scss"],
  animations: [
    trigger("menuCollapse", [
      state(
        "collapsedMenu",
        style({
          height: 0,
          visibility: "hidden",
        })
      ),
      state(
        "expandedMenu",
        style({
          height: "*",
          visibility: "visible",
        })
      ),
      transition("collapsedMenu => expandedMenu", animate("100ms ease-out")),
      transition("expandedMenu => collapsedMenu", animate("50ms ease-in")),
    ]),
    trigger("selectMenuItem", [
      state(
        "expandedMenu",
        style({
          backgroundColor: "#f0f0f0",
        })
      ),
      state(
        "collapsedMenu",
        style({
          backgroundColor: "*",
        })
      ),
      transition("collapsedMenu => expandedMenu", animate("200ms ease-out")),
      transition("expandedMenu => collapsedMenu", animate("50ms ease-in")),
    ]),
  ],
})
export class MainComponent implements OnInit {
  @Input() mouseUp: boolean;
  body = document.querySelector("body");
  show: boolean;
  showMenu: boolean;
  showSidebar: boolean;
  userRole: string;
  cultureScript = null;
  @Input() templateContext: any;

  static initMomentSettings() {
    const culture = sessionStorage.getItem("currentCulture");
    moment.locale(culture);
    localStorage.setItem(
      "dateFormatString",
      moment.localeData().longDateFormat("L")
    );
    sessionStorage.setItem(
      "dateFormatString",
      moment.localeData().longDateFormat("L")
    );
  }

  constructor(
    private explorerService: ExplorerService,
    private utilService: UtilService,
    private translateService: TranslateService,
    private klLoading: KlLoadingService,
    private router: Router,
    private apiService: ApiService
  ) {
    MainComponent.initMomentSettings();
    this.initWijmoCulture();
  }

  ngOnInit() {
    this.showMenu = false;
    this.klLoading.show("loading");
    this.userRole = null;
    if (window.innerWidth > 767) {
      this.body.classList.remove("aside-collapsed");
    } else {
      this.body.classList.add("aside-collapsed");
    }
    this.apiService.getAllData("user/my").subscribe(
      (responseUser) => {
        if (responseUser.roles.length > 0) {
          this.apiService
            .getDataById(
              "user-role-permission/getbyrole",
              responseUser.roles[0].role.id
            )
            .subscribe(
              (responsePermission) => {
                this.klLoading.hide();
                this.show = false;
                this.showMenu = true;
                this.userRole = responseUser.roles[0].role.type;
                this.explorerService.setUserProfile(responseUser);
                this.explorerService.setUserRoles(responsePermission);
              },
              () => {
                this.klLoading.hide();
                this.router.navigateByUrl("/auth/login");
              }
            );
        } else {
          this.klLoading.hide();
          this.router.navigateByUrl("/auth/login");
        }
      },
      () => {
        this.klLoading.hide();
        this.router.navigateByUrl("/auth/login");
      }
    );
  }

  initWijmoCulture() {
    const culture = sessionStorage.getItem("currentLanguage");
    if (this.cultureScript !== null) {
      this.cultureScript.parentElement.removeChild(this.cultureScript);
    }
    this.cultureScript = document.createElement("script");
    this.cultureScript.addEventListener("load", () => {
      wjCore.Control.invalidateAll();
    });
    this.cultureScript.src =
      "/assets/cultures/wijmo.culture." + culture + ".js";
    this.cultureScript.type = "text/javascript";
    this.cultureScript.charset = "utf-8";
    this.cultureScript.async = true;
    document.head.appendChild(this.cultureScript);
  }
}
